import React from 'react';
import CTA from '../../Content/MarketingSectionContainer/global/CTA';

const CTAContainer = ({ component, state }) => {
  const user = state?.cscAdminProfile?.data || {};
  const primaryCta = component.button || {};
  const display_settings = component.display_settings || {};
  const displaySettings = Array.isArray(display_settings)
    ? display_settings.map((s) => String(s).toLowerCase().trim())
    : [];

  const isMobile = displaySettings.includes('mobile');
  const isTablet = displaySettings.includes('tablet');
  const isDesktop = displaySettings.includes('desktop');

  const allSelected = isMobile && isTablet && isDesktop;
  const noneSelected = !isMobile && !isTablet && !isDesktop;

  let css = '';
  const baseHide = `.crear-gr-div { display: none !important; }`;
  const showFlex = `.crear-gr-div { display: flex !important; }`;

  const mediaQueries = {
    mobile: `@media (max-width: 767px) { ${showFlex} }`,
    tablet: `@media (min-width: 768px) and (max-width: 1024px) { ${showFlex} }`,
    desktop: `@media (min-width: 1025px) { ${showFlex} }`,
  };

  if (noneSelected) {
    css = baseHide;
  } else if (!allSelected) {
    css = baseHide;
    if (isMobile) css += mediaQueries.mobile;
    if (isTablet) css += mediaQueries.tablet;
    if (isDesktop) css += mediaQueries.desktop;
  }

  if(user && user.isAgent) {
    return <></>;
  }

  return (
    <>
      {css && <style>{css}</style>}
      <div className='crear-gr-div'>
        <CTA
          cta={{
            type: primaryCta.type,
            title: primaryCta.title,
            action: primaryCta.action,
            customBtnCss: 'btn btn-gr crear-gr-btn',
          }}
          variant='primary'
        />
      </div>
    </>
  );
};

export default CTAContainer;
